import styled from "styled-components";

export const Container = styled.ul`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  margin-top: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
  }
`;

export const SectionTitle = styled.p`
  font-weight: bold;
  margin: 14px 0 14px;
`;